import { baseApi } from "@/shared/api";
import type { AuditListResponse } from "@/shared/types/audit";

export const attachedDocumentAuditApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAttachedDocumentAudit: builder.query<AuditListResponse, number>({
      query: (documentId) => ({
        url: `/api/audit/?target_type=attached_document&target_id=${documentId}&page_size=50`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: (_result, _error, documentId) => [
        { type: "AuditEntries" as const, id: `attached-document-${documentId}` },
      ],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetAttachedDocumentAuditQuery } = attachedDocumentAuditApi;
